/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_RateInputs */

const en_reference_field_rate = /** @type {(inputs: Reference_Field_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate (%)`)
};

/**
* | output |
* | --- |
* | "Rate (%)" |
*
* @param {Reference_Field_RateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_rate = /** @type {((inputs?: Reference_Field_RateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_RateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_rate(inputs)
});